import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PatientPayerData } from '../../../../@core/interfaces/patient-services/patient-payer';

@Component({
  selector: 'ngx-policy-header-details',
  templateUrl: './policy-header-details.component.html',
  styleUrls: ['./policy-header-details.component.scss']
})
export class PolicyHeaderDetailsComponent implements OnInit {
    payerList: Array<any> = [];
  selectedPayerDet:any;
  showPayerCoverageDet: boolean = false;
  coveragePercentage: any;
  coverageMaxAmountorDisplay: any;
  @Input() regId:string;
   @Input() selectedPayer:string;
  protected readonly unsubscribe$ = new Subject<void>();
    private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  constructor(private patPayerSrvc: PatientPayerData) { }

  ngOnInit(): void {
    this.policyDetails();
  }
  policyDetails(){
         this.patPayerSrvc.getById(`PatientPayer/${this.tenandId}/${this.branchId}/${this.regId}/${this.selectedPayer}/GetPatientPayerPolicyDetails`).
          pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
            this.payerList = data.map((arg => {
              if (!!arg?.insDet) {
                return { ...arg, payerName: arg?.insDet?.payerName, payerId: arg?.insDet?.id, refPayerId: arg?.id }
              }
              else if (!!arg?.sponDet) {
                return { ...arg, payerName: arg?.sponDet?.payerName, payerId: arg?.sponDet?.id, refPayerId: arg?.id }
              } else {
                return { ...arg, payerName: arg?.corpDet?.payerName, payerId: arg?.corpDet?.id, refPayerId: arg?.id }
              }

            }))
           this.selectedPayerDet=this.payerList.find(x=>x?.payerId==this.selectedPayer);
           this.showPayerCoverageDet=this.payerList[0];
          });
  }
  selectedPayers(){
    this.selectedPayerDet=this.payerList.find(x=>x?.payerId==this.selectedPayer);
  }
}
